import { api } from "./client.js";
import type { Notification, SendNotificationBody } from "@wwrp/shared";

export interface NotificationListResponse {
  items: Notification[];
  total: number;
  unread: number;
  limit: number;
  offset: number;
}

export const notificationsApi = {
  list: (params?: { unreadOnly?: boolean; limit?: number; offset?: number }) => {
    const q = new URLSearchParams();
    if (params?.unreadOnly) q.set("unreadOnly", "true");
    if (params?.limit !== undefined) q.set("limit", String(params.limit));
    if (params?.offset !== undefined) q.set("offset", String(params.offset));
    const qs = q.toString();
    return api.get<NotificationListResponse>(`/notifications${qs ? `?${qs}` : ""}`);
  },

  unreadCount: () => api.get<{ unread: number }>("/notifications/unread-count"),

  markRead: (id: number) => api.post<Notification>(`/notifications/${id}/read`),

  markAllRead: () => api.post<{ updated: number }>("/notifications/read-all"),

  remove: (id: number) => api.delete<{ ok: true }>(`/notifications/${id}`),

  send: (body: SendNotificationBody) => api.post<{ accepted: true }>("/notifications/send", body),
};
